<template>
    <div class="posts-wrapper packages">
        <!-- <div class="page-title">Contenido Reciente</div> -->
        <div class="box-white-wrapper">
          <vs-table :data="tempPackges" pagination max-items="50">
              <template slot="header" v-if="userInfoData.role != Roles.Distribuitor">
                  <vs-button color="primary" to="/pre-alert" type="border" icon="cloud_download">Descargar XLS</vs-button>
              </template>
              <template slot="thead">
                  <vs-th sort-key="tracking">Tracking</vs-th>
                  <vs-th sort-key="name">Nombre </vs-th>
                  <vs-th sort-key="email">Email </vs-th>
                  <vs-th sort-key="createdAt"> Fecha Registro </vs-th>
                  <vs-th sort-key="statusname"> Estado </vs-th>
                  <vs-th sort-key="id" class="width-30"></vs-th>
              </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td :data="data[indextr].tracking">
                      {{data[indextr].tracking}}
                  </vs-td>
                  <vs-td :data="data[indextr]">
                      {{data[indextr].firstName +' '+ data[indextr].lastName}}
                  </vs-td>
                  <vs-td :data="data[indextr].email">
                      <a :href="`mailto:${data[indextr].email}`">{{data[indextr].email}}</a>
                  </vs-td>
                  <vs-td :data="data[indextr].createdAt">
                      {{data[indextr].createdAt | moment('DD/MM/YYYY')}}
                  </vs-td>
                  <vs-td :data="data[indextr].statuscode">
                      <span :class="`status status-${data[indextr].statuscode}`">
                          {{data[indextr].statusname}}
                      </span>
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                      <div class="table-actions">
                            <router-link :to="`/package/${data[indextr].id}`"><feather type="eye"/></router-link>
                      </div>
                  </vs-td>
                  </vs-tr>
              </template>
          </vs-table>
        </div>
        <modalPackage @modal-event="handleActionModalPackage" :packID="packageId" :selected="pkgCurrentStatus" :show="modalActive"></modalPackage>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import PackageModel from "@/models/PackageModel"
import { required } from 'vuelidate/lib/validators'
import PackageDataService from "@/services/PackageDataService"
import ModalPackage from '@/components/Modal/PackageStatus.vue'
export default {
  name: 'PackagesReport',
  mixins: [helper],
  components: {
    ModalPackage
  },
  data () {
    return {
      packageId: "",
      pkgCurrentStatus:{},
      modalActive: false,
      confirmStatus: false,
      searchkeyword: '',
      message: '',
      postId: 0,
      page: 1,
      countPost:0,
      packageStats: [],
      packID: 0,
      newStatus: {},
      package: new PackageModel(),
      packages: [],
      tempPackges: [],
      Roles: [],
      boxActive: null
    }
  },
  created(){
    this.Roles = Role
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted (){
    this.getPackagesStats()
    this.retrievePackages()
  },
  validations: {
    package: 
      { 
        status: { required },
      },
  },
  methods: {
    handleActionModalPackage(response){
      if(response.error !=  undefined){
        if(!response.error){
          this.retrievePackages()
          this.getPackagesStats()
          this.$vs.notify({title:'Información!',text:'El estado del paquete fue modificado exitosamente!',color:'success',icon:'check'})
        }else{
            this.$vs.notify({title:'Información!',text:'Error actualizando el estado del paquete',color:'danger',icon:'error_outline'})
        }
      }
      this.modalActive = response.active
      
    },
    changePackageStatus(value){
      if(this.userInfoData.role != 'Customer'){
        this.packageId   = value
        this.pkgCurrentStatus = this.currentPackStatus(value)
        this.modalActive = true
      }
    },
    currentPackStatus(id) {
        let _objPack = this.packages.filter((item) => {
          return id === item.id
        })
        _objPack =  _objPack[0]
        let newStatus = { code: _objPack.statuscode, name: _objPack.statusname}
        return newStatus
    },
    retrievePackages() {
        PackageDataService.getAll()
        .then(response => {
          this.packages    = response.data;
          this.tempPackges = this.packages
          this.$Progress.finish()
        })
        .catch(e => {
          console.log(e)
          this.$Progress.finish()
          this.$vs.notify({title:'Error!',text:'Error obteniendo los paquetes!',color:'danger',icon:'error_outline'})
        });
    },
    getPackagesStats() {
        PackageDataService.getPackStats()
        .then(response => {
            this.packageStats = response.data[0];
        })
        .catch(e => {
            console.log(e)
            this.$vs.notify({title:'Error!',text:'Error obteniendo las estadisticas de los clientes!',color:'danger',icon:'error_outline'})
        });
    },
    filterPackages(index){
      if(this.boxActive != index){
        this.boxActive = index
        this.tempPackges = this.packages.filter((item) => {              
            return index == item.st01Code
        })
      }else{
        this.tempPackges = this.packages
        this.boxActive   = null
      }
    }
  }
}
</script>
